import axiosIS from "@/api/net/axios.js";
import { platFormBaseUrl } from "@/config/apiConfig.js";

export const PAYMENT_SOURCE = Object.freeze({
  PRICING: "pricing",
  FALLBACK: "fallback",
});

// apiKey列表
export function getApiKeyList(data = {}) {
  return axiosIS(`${platFormBaseUrl}/api/api-key/list`, data, {
    method: "get",
  });
}
// 创建apiKey
export function addApiKey(data = {}) {
  return axiosIS(`${platFormBaseUrl}/api/api-key/create`, data, {
    method: "post",
  });
}
// 修改apiKey
export function editApiKey(data = {}) {
  return axiosIS(`${platFormBaseUrl}/api/api-key/modify`, data, {
    method: "post",
  });
}
// 删除apiKey
export function delApiKey(data = {}) {
  return axiosIS(`${platFormBaseUrl}/api/api-key/del`, data, {
    method: "post",
  });
}

// 账单数据
export function getBilling(data = {}) {
  return axiosIS(`${platFormBaseUrl}/api/billing/detail`, data, {
    method: "get",
  });
}

// 消费记录
export function getExpense(data = {}) {
  return axiosIS(`${platFormBaseUrl}/api/billing/expense/detail`, data, {
    method: "get",
  });
}

// 导出消费记录
export function exportExpenseDetail(data = {}) {
  return axiosIS(`${platFormBaseUrl}/api/billing/expense-detail/export`, data, {
    method: "get",
  });
}

// 充值记录
export function getCharge(data = {}) {
  return axiosIS(`${platFormBaseUrl}/api/billing/charge/record`, data, {
    method: "get",
  });
}

// 获取sku列表
export function getSku(data = {}) {
  return axiosIS(`${platFormBaseUrl}/api/payment/products`, data, {
    method: "get",
  });
}

// 支付
export function pay(data = {}, source) {
  const requestData = source ? { ...data, source } : data;

  return axiosIS(`${platFormBaseUrl}/api/payment/checkout`, requestData, {
    method: "post",
  });
}

// 获取发票地址
export function getInvoice(data = {}) {
  return axiosIS(`${platFormBaseUrl}/api/payment/invoice/download`, data, {
    method: "get",
  });
}

// 企业及个人认证
export function certifyInfo(data = {}) {
  return axiosIS(`${platFormBaseUrl}/api/open/certification`, data, {
    method: "post",
  });
}

// 认证状态查询
export function queryCertification(data = {}) {
  return axiosIS(`${platFormBaseUrl}/api/open/query/certification`, data, {
    method: "get",
  });
}

// 待开发票订单
export function getPendingInvoice(data = {}) {
  return axiosIS(`${platFormBaseUrl}/api/billing/pending/invoice/orders`, data, {
    method: "get",
  });
}

// 用户已申请发票列表
export function getApplyInvoiceList(data = {}) {
  return axiosIS(`${platFormBaseUrl}/api/billing/invoice/apply/list`, data, {
    method: "get",
  });
}

// 申请开发票
export function applyInvoice(data = {}) {
  return axiosIS(`${platFormBaseUrl}/api/billing/apply/invoice`, data, {
    method: "post",
  });
}

// 查询支付信息
export function chargePaymentDetail(data = {}) {
  return axiosIS(`${platFormBaseUrl}/api/payment/charge_detail`, data, {
    method: "get",
  });
}
